import { isPagesRoute } from '../../constants/PagesConstants';
import {
  PAGE_CREATE_CONTENT,
  PAGE_CREATE_DRINK_ITEM,
  PAGE_CREATE_MENU,
  PAGE_CREATE_MENU_ITEM,
  PAGE_CREATE_MODIFIER,
  PAGE_CREATE_RESTAURANT,
  PAGE_DESIGN_COLORS,
  PAGE_DESIGN_FONTS,
  PAGE_DISCOVERY_CONTENT,
  PAGE_EDIT_CONTENT,
  PAGE_EDIT_DRINK_ITEM,
  PAGE_EDIT_MENU,
  PAGE_EDIT_MENU_ITEM,
  PAGE_EDIT_MODIFIER,
  PAGE_EDIT_RESTAURANT,
  PAGE_EMAIL_MANAGER,
  PAGE_MEDIA_LIBRARY,
  PAGE_PRINTING_MATERIALS,
  PAGE_COMING_SOON,
  PAGE_PROMOTIONS,
  PAGE_RESERVATION_LINKS,
  PAGE_ONLINE_ORDERING,
  PAGE_SETTINGS,
  PAGE_SETTINGS_ACCOUNT,
  PAGE_BRAND_PROFILE,
  PAGE_LOCATION_PROFILE,
  PAGE_MENUS
} from '../../constants/UriConstants';

export type SidebarNavId =
  | 'locationProfile'
  | 'pages'
  | 'marketing'
  | 'marketing.promotions'
  | 'marketing.emails'
  | 'marketing.discovery'
  | 'marketing.printingMaterials'
  | 'marketing.comingSoon'
  | 'design'
  | 'design.colors'
  | 'design.fonts'
  | 'settings'
  | 'brandProfile'
  | 'locationProfile.menus';

export type SidebarRouteMatcher = {
  /** Match `/{path}` or `/{path}/*` */
  paths?: string[];
  /** Match pathname exactly */
  exactPaths?: string[];
  /** Match when pathname includes the segment */
  includes?: string[];
  /** Custom predicate */
  test?: (pathname: string) => boolean;
  /** Active when any listed nav item is active (for parent sections) */
  anyOf?: SidebarNavId[];
};

export type SidebarNavItemConfig = {
  match: SidebarRouteMatcher;
};

export const SIDEBAR_NAV_CONFIG: Record<SidebarNavId, SidebarNavItemConfig> = {
  locationProfile: {
    match: {
      paths: [
        PAGE_EDIT_RESTAURANT,
        PAGE_RESERVATION_LINKS,
        PAGE_ONLINE_ORDERING,
        PAGE_MEDIA_LIBRARY,
        PAGE_LOCATION_PROFILE
      ],
      exactPaths: [`/${PAGE_SETTINGS}`],
      includes: ['/basic-information', '/address', '/hours', '/reservation-links', '/online-ordering'],
      test: (pathname) => pathname.includes(`/${PAGE_MENUS}`)
    }
  },
  'locationProfile.menus': {
    match: {
      paths: [PAGE_MENUS]
    }
  },
  pages: {
    match: {
      test: isPagesRoute
    }
  },
  'marketing.promotions': {
    match: {
      paths: [PAGE_PROMOTIONS]
    }
  },
  'marketing.emails': {
    match: {
      paths: [PAGE_EMAIL_MANAGER]
    }
  },
  'marketing.discovery': {
    match: {
      paths: [PAGE_DISCOVERY_CONTENT],
      includes: [PAGE_CREATE_CONTENT, PAGE_EDIT_CONTENT]
    }
  },
  'marketing.printingMaterials': {
    match: {
      paths: [PAGE_PRINTING_MATERIALS]
    }
  },
  'marketing.comingSoon': {
    match: {
      paths: [PAGE_COMING_SOON]
    }
  },
  marketing: {
    match: {
      anyOf: ['marketing.promotions', 'marketing.emails', 'marketing.discovery', 'marketing.printingMaterials', 'marketing.comingSoon']
    }
  },
  design: {
    match: {
      anyOf: ['design.colors', 'design.fonts']
    }
  },
  'design.colors': {
    match: {
      paths: [PAGE_DESIGN_COLORS]
    }
  },
  'design.fonts': {
    match: {
      paths: [PAGE_DESIGN_FONTS]
    }
  },
  settings: {
    match: {
      paths: [PAGE_SETTINGS_ACCOUNT]
    }
  },
  brandProfile: {
    match: {
      includes: [PAGE_BRAND_PROFILE]
    }
  }
};

export const RESTAURANT_DROPDOWN_HIDDEN_MATCHER: SidebarRouteMatcher = {
  includes: [
    PAGE_CREATE_MODIFIER,
    PAGE_EDIT_MODIFIER,
    PAGE_CREATE_DRINK_ITEM,
    PAGE_EDIT_DRINK_ITEM,
    PAGE_CREATE_MENU,
    PAGE_EDIT_MENU,
    PAGE_CREATE_MENU_ITEM,
    PAGE_EDIT_MENU_ITEM,
    PAGE_CREATE_RESTAURANT
  ]
};
